import React from "react";
import BuyersTable from "./buyersTable";

const index = () => {
  return (
    <div>
      <BuyersTable />
    </div>
  );
};

export default index;
